module.exports = __webpack_public_path__ + "img/bayantel_logo@2x.d4d5e83b.png";